// Original: https://raw.githubusercontent.com/PrismJS/prism-themes/master/themes/prism-ghcolors.css
const theme = {
  plain: {
    color: '#608BD8',
    backgroundColor: '#EBEEF2',
  },
  styles: [
    {
      types: ['comment', 'prolog', 'doctype', 'cdata'],
      style: {
        color: '#8791A3',
      },
    },
    {
      types: ['namespace'],
      style: {
        opacity: 0.7,
      },
    },
    {
      types: ['string', 'attr-value'],
      style: {
        color: '#F3446A',
      },
    },
    {
      types: ['punctuation', 'operator'],
      style: {
        color: '#3B4C6A',
      },
    },
    {
      types: [
        'entity',
        'url',
        'symbol',
        'number',
        'boolean',
        'variable',
        'constant',
        'property',
        'regex',
        'inserted',
      ],
      style: {
        color: '#2BAB7C',
      },
    },
    {
      types: ['atrule', 'attr-name'],
      style: {
        color: '#19C2D4',
      },
    },
    {
      types: ['function', 'deleted', 'tag'],
      style: {
        color: '#F85B30',
      },
    },
    {
      types: ['function-variable', 'parameter'],
      style: {
        color: '#714DC0',
      },
    },
    {
      types: ['selector', 'keyword'],
      style: {
        color: '#3E6EC0',
      },
    },
  ],
}

export default theme

export const stellateTheme = {
  plain: {
    color: '#608BD8',
    backgroundColor: 'transparent',
  },
  styles: [
    {
      types: ['comment', 'prolog', 'doctype', 'cdata'],
      style: {
        color: '#8791A3',
      },
    },
    {
      types: ['namespace'],
      style: {
        opacity: 0.7,
      },
    },
    {
      types: ['string', 'attr-value'],
      style: {
        color: '#31C48F',
      },
    },
    {
      types: ['punctuation', 'operator'],
      style: {
        color: '#7F90AD',
      },
    },
    {
      types: [
        'entity',
        'url',
        'symbol',
        'number',
        'boolean',
        // 'variable',
        'constant',
        'property',
        'regex',
        'inserted',
      ],
      style: {
        color: '#FF7752',
      },
    },
    {
      types: ['atrule', 'attr-name'],
      style: {
        color: '#19C2D4',
      },
    },
    {
      types: ['function', 'deleted', 'tag'],
      style: {
        color: '#D782FF',
      },
    },
    {
      types: ['function-variable', 'parameter'],
      style: {
        color: '#7F90AD',
      },
    },
    {
      types: ['selector', 'keyword'],
      style: {
        color: '#EB9B00',
      },
    },
  ],
}
